// extracted by mini-css-extract-plugin
export default {"score":"PasswordStrength_score__tLQSX"};